export enum CurrencyType {
    Sapphire = "Sapphire",
    Emerald = "Emerald",
    Ruby = "Ruby",
    Diamond = "Diamond",
}
